import React from 'react';
import { Link } from 'react-router-dom';

const HomePage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h1 className="text-4xl font-bold text-primary mb-4">GitHub HTML Tool</h1>
          <p className="text-xl text-gray-600">
            Connect to GitHub, paste code, and preview HTML content with ease.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="bg-white p-6 rounded-lg shadow-md">
            <div className="text-primary mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"></path>
                <line x1="16" y1="8" x2="2" y2="22"></line>
                <line x1="17.5" y1="15" x2="9" y2="15"></line>
              </svg>
            </div>
            <h2 className="text-2xl font-bold mb-2">Code Editor</h2>
            <p className="text-gray-600 mb-4">
              Paste your code, specify a filename, and submit it directly to your GitHub repository.
            </p>
            <Link 
              to="/editor" 
              className="github-btn inline-block"
            >
              Go to Editor
            </Link>
          </div>
          
          <div className="bg-white p-6 rounded-lg shadow-md">
            <div className="text-secondary mb-4">
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                <polyline points="2 17 12 22 22 17"></polyline>
                <polyline points="2 12 12 17 22 12"></polyline>
              </svg>
            </div>
            <h2 className="text-2xl font-bold mb-2">HTML Preview</h2>
            <p className="text-gray-600 mb-4">
              Real-time preview of HTML content before committing to your GitHub repository.
            </p>
            <Link 
              to="/editor" 
              className="secondary-btn inline-block"
            >
              Try Preview
            </Link>
          </div>
        </div>
        
        <div className="bg-light rounded-lg p-6 shadow-md">
          <h2 className="text-2xl font-bold mb-4">How It Works</h2>
          
          <div className="space-y-4">
            <div className="flex items-start">
              <div className="bg-primary text-white rounded-full w-8 h-8 flex items-center justify-center font-bold mr-4 shrink-0">
                1
              </div>
              <div>
                <h3 className="font-semibold text-lg">Connect to GitHub</h3>
                <p className="text-gray-600">
                  Authenticate with your GitHub account to access your repositories.
                </p>
              </div>
            </div>
            
            <div className="flex items-start">
              <div className="bg-primary text-white rounded-full w-8 h-8 flex items-center justify-center font-bold mr-4 shrink-0">
                2
              </div>
              <div>
                <h3 className="font-semibold text-lg">Select Repository</h3>
                <p className="text-gray-600">
                  Choose the repository where you want to commit your code.
                </p>
              </div>
            </div>
            
            <div className="flex items-start">
              <div className="bg-primary text-white rounded-full w-8 h-8 flex items-center justify-center font-bold mr-4 shrink-0">
                3
              </div>
              <div>
                <h3 className="font-semibold text-lg">Paste and Save</h3>
                <p className="text-gray-600">
                  Paste your code, specify a filename, and commit directly to your repository.
                </p>
              </div>
            </div>
            
            <div className="flex items-start">
              <div className="bg-primary text-white rounded-full w-8 h-8 flex items-center justify-center font-bold mr-4 shrink-0">
                4
              </div>
              <div>
                <h3 className="font-semibold text-lg">Preview HTML</h3>
                <p className="text-gray-600">
                  If your content is HTML, get a real-time preview before committing.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomePage; 